import { patientActions, noteActions, cdvActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'
import _ from 'lodash';

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.cdv };
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.cdv };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [noteActions.deleteNoteSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [noteActions.deleteNoteFailure]: (state, action) => {
        log.error('Error deleting note.  noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [noteActions.saveAddendumFailure]: (state, action) => {
        log.error('Error saving addendum.  noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [cdvActions.refreshCdvSuccess]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.ptno === action.payload.ptno) {
                delete state[x.id];
            }
        })
        return _.merge(state, action.payload.response.entities.cdv);
    },
    [patientActions.refreshFotoEpisodesForPatientSuccess]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.ptno === action.payload.ptno) {
                delete state[x.id];
            }
        })
        return _.merge(state, action.payload.fotoRefresh.entities.cdv);
    }

})


